import Axios, { AxiosRequestConfig } from 'axios';

import { getTicketUid } from '@core/utils';
import { CompanyCard } from './model';

const BUSINESS_HUB_API_ENDPOINT = `${location.origin}/snc-business-hub-services/api/`;

const businessHubApi = {
	fetchCompanyCardByTaxCode: (taxCode: string, onComplete: (companyCard: CompanyCard) => void) => {
		const ticketUID = getTicketUid();

		return new Promise<void>((resolve, reject) => {
			const request: AxiosRequestConfig = {
				headers: {
					ticketuid: ticketUID,
				},
				method: 'get',
				url: `${BUSINESS_HUB_API_ENDPOINT}v2/companies/${taxCode}/card`,
			};

			Axios(request)
				.then(response => {
					onComplete(response.data as CompanyCard);
					resolve();
				})
				.catch(() => {
					onComplete(null);
					reject();
				});
		});
	},
};

export { businessHubApi };
